import React from "react";
import { Page } from "../../components/page/page";
import styles from "./magical-insight.module.css";
import { ChooseButton } from "../../components/choose-button/choose-button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setMagicalInsight } from "../../store/stateSlice";

const options = [
  {
    value: "Discover my hidden powers",
    icon: "🧭",
  },
  {
    value: "Identify my spiritual archetype",
    icon: "🧿",
  },
  {
    value: "Find marks & symbols that will guide me",
    icon: "✨",
  },
  {
    value: "Unravel my destiny and calling",
    icon: "🎱",
  },
  {
    value: "Boost my influence and intuition",
    icon: "💬",
  },
  {
    value: "Explore my innate magical potential",
    icon: "🔮",
  },
];

const MagicalInsightPage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="What magical insight are you hoping to discover?"
      hideContinueButton={true}
      currentStep={1}
    >
      <ul className={styles.list}>
        {options.map((option, i) => (
          <li key={i}>
            <Link
              to="../intuition"
              onClick={() => dispatch(setMagicalInsight(option.value))}
            >
              <ChooseButton icon={option.icon}>{option.value}</ChooseButton>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export { MagicalInsightPage };
